import { render, staticRenderFns } from "./VSelectDateReminderDefault.vue?vue&type=template&id=89a52ca0&scoped=true&"
import script from "./VSelectDateReminderDefault.vue?vue&type=script&lang=js&"
export * from "./VSelectDateReminderDefault.vue?vue&type=script&lang=js&"
import style0 from "./VSelectDateReminderDefault.vue?vue&type=style&index=0&id=89a52ca0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a52ca0",
  null
  
)

export default component.exports